$.fn.addSpin = function () {
    this.removeSpin();
    var button;
    if (this.is('button')) {
        button = this.find('span, a');
    } else {
        button = this.find('[type=submit] span, [type=submit] a');
    }
    button.prepend('<i class="spin">');
    return this;
};
$.fn.removeSpin = function () {
    this.find('i.spin').remove();
    return this;
};

$.fn.highlightFlash = function (timeout) {
    timeout = timeout || 2000;
    var className = 'highlight-flash';
    var self = this;
    self.addClass(className);
    setTimeout(function () {
        self.removeClass(className).addClass(className + '--off');
    }, timeout);
    return self;
};

$.fn.cursorRange = function (start, end) {
    // TODO IE support http://stackoverflow.com/questions/235411
    if (start !== undefined) {
        // Set
        if (end === undefined) {
            end = start;
        }
        this.filter('textarea, input').each(function () {
            this.selectionStart = start;
            this.selectionEnd = end;
        });
        
        return this;
    } else {
        // Get
        var input = this.filter('textarea, input').get(0);
        
        return {
            start: input.selectionStart,
            end: input.selectionEnd
        };
    }
};

$.fn.serializeForm = function () {
    var params = {};
    _.each(this.serializeArray(), function (item, i) {
        params[item.name] = item.value;
    });
    return params;
};



//////////////////
// WEBPACK FOOTER
// ./app/src/lib/jqueryplugins.js
// module id = /SwS
// module chunks = 1